(function(){
  var root = document.getElementById('lvl-cc');
  if (!root || root.dataset.lvlCcInit === '1') return;
  root.dataset.lvlCcInit = '1';
  root.setAttribute('data-active', 'cbd');

  var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
  var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));

  function activate(key, focusTab){
    tabs.forEach(function(t){
      var on = t.dataset.key === key;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      t.classList.toggle('is-active', on);
      if (on && focusTab) t.focus();
    });
    panels.forEach(function(p){
      var on = p.dataset.key === key;
      p.hidden = !on;
      p.classList.toggle('is-active', on);
    });
    root.setAttribute('data-active', key);
  }

  tabs.forEach(function(tab, idx){
    tab.addEventListener('click', function(){ activate(tab.dataset.key, false); });
    tab.addEventListener('keydown', function(e){
      var key = e.key;
      if (key === 'ArrowRight' || key === 'ArrowDown'){
        e.preventDefault();
        activate(tabs[(idx + 1) % tabs.length].dataset.key, true);
      } else if (key === 'ArrowLeft' || key === 'ArrowUp'){
        e.preventDefault();
        activate(tabs[(idx - 1 + tabs.length) % tabs.length].dataset.key, true);
      } else if (key === 'Home'){
        e.preventDefault();
        activate(tabs[0].dataset.key, true);
      } else if (key === 'End'){
        e.preventDefault();
        activate(tabs[tabs.length - 1].dataset.key, true);
      }
    });
  });
})();
